import { Component, Input } from '@angular/core';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'app-sub-nav',
  templateUrl: './sub-nav.component.html',
  styleUrls: ['./sub-nav.component.scss'],
  standalone: false
})
export class SubNavComponent extends BreadcrumbsComponent {
  /**
   * Where the back button (chevron) sends you.
   */
  @Input() returnPath!: string;

    /**
   * Whether the path is a routerlink or an href
   */
  @Input() returnPathType: 'href' | 'routerLink' = 'routerLink';

  @Input() buttonSize: 'small' | 'medium' = 'medium';
}
